import $ from 'jquery';

import 'normalize.css';
import '@fortawesome/fontawesome-free/css/all.css';
import '@/assets/css/style.scss';

$(() => {
  $(".nav-open").on("click", () => {
    $(".nav-dropdown").addClass("open");
  });

  $(".nav-close").on("click", () => {
    $(".nav-dropdown").removeClass("open");
  });

  $(".accordion .title").on("click", (e) => {
    $(".accordion .text").slideUp();
    $(".accordion").removeClass("open");
    $(e.target).parent().addClass("open");
    $(e.target).siblings(".text").slideDown();
  });

  var pageNumber = 1;

  function load_posts() {
    pageNumber++;
    var str = '&pageNumber=' + pageNumber + '&action=more_post_ajax';
    $.ajax({
      type: "POST",
      dataType: "html",
      url: ajax.url,
      data: str,
      success: function (data) {
        var $data = $(data);
        if ($data.length) {
          $(".posts").append($data);

          if ($data.length < 3) {
            $(".more-posts").hide();
            $(".posts").append('<h3 class="col col-md-12">There are no older posts.</h3>');
          }
        } else {
          $(".more-posts").hide();
          $(".posts").append('<h3 class="col col-md-12">There are no older posts.</h3>');
        }
      },
      error: function (jqXHR, textStatus, errorThrown) {
        $loader.html(jqXHR + " :: " + textStatus + " :: " + errorThrown);
      }

    });
    return false;
  }

  $(".more-posts").on("click",function(){
    load_posts();
  });

  $(".testimonial-slider").bxSlider({
    autoplay: true,
    controls: false
  });
});